<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
  created () {
    this.getTimer()
  },
  methods: {
    async getTimer () {
      const { data } = await this.$get('https://ow.schoolpi.net/ow/maintenance')
      this.$store.commit('setBlankData', data)
    }
  }
}
</script>

<style lang="scss">
// @font-face {
//   font-family: "PingFang";
//   src: url("./assets/pingfang.otf");
// }
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: "PingFang", "Helvetica Neue", Helvetica, "PingFang SC",
    "Microsoft YaHei", Tahoma, Arial;
}
li {
  list-style: none;
}
.el-carousel {
  min-height: 450px !important;
}
.el-carousel__container {
  min-height: 450px !important;
  padding-bottom: 50px !important;
}
.ele-msg .el-message__icon{
  font-size: 0.24rem;
}
.breadcrumb {
        display: flex;
        font-size: 14px;
        color: #999999;
        line-height: 20px;
        margin-bottom: 32px;
        .breadcrumb-img {
            width: 12px;
            height: 14px;
            vertical-align: middle;
            margin-right: 6px;
        }

        .breadcrumb-item {
            color: #999999;
            text-decoration: none;
            margin: 0 2px;
            cursor: pointer;
            &:first-child {
                margin-left: 0;
            }

            &:last-child {
                color: #4E55AF;
            }
        }
    }
.el-dialog {
  position: relative;
}
// .el-dialog__wrapper .el-dialog:before {
//   content: "";
//   position: absolute;
//   top: 0;
//   left: 0;
//   right: 0;
//   height: 6px;
//   background: #0d70ff;
//   background: linear-gradient(135deg, #0d70ff, #0db9ff);
//   border-top-right-radius: 2px;
//   border-top-left-radius: 2px;
// }
.el-message-box {
  position: relative;
  border: 0 !important;
  @media screen and (max-width: 850px) {
    width: 300px !important;
  }
}
// .el-message-box:before {
//   content: "";
//   position: absolute;
//   top: 0;
//   left: 0;
//   right: 0;
//   height: 6px;
//   background: #0d70ff;
//   background: -webkit-linear-gradient(315deg, #0d70ff, #0db9ff);
//   background: -moz-linear-gradient(315deg, #0d70ff 0, #0db9ff 100%);
//   background: linear-gradient(135deg, #0d70ff, #0db9ff);
//   border-top-right-radius: 2px;
//   border-top-left-radius: 2px;
// }
</style>
